/** PostgreSQL bigint byte counts arrive over JSON as decimal strings. */
export function attachmentSizeBytes(value: unknown): number {
  const bytes = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : 0;
  // Match the server delivery planner's handling of absent/invalid byte counts.
  return Number.isFinite(bytes) && bytes > 0 ? Math.floor(bytes) : 0;
}

/** Also accepts legacy compose state that predates API normalization. */
export function totalAttachmentBytes(attachments: ReadonlyArray<{ size?: unknown }>): number {
  return attachments.reduce((sum, attachment) => sum + attachmentSizeBytes(attachment.size), 0);
}
